<section class="split-content">
  <section class="nav-bar">
    <h2>{{ title }}</h2>
    <ng-content select="[navigation]"></ng-content>
  </section>
  <section class="content">
    <ng-content select="[main]"></ng-content>
  </section>
</section>
